var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWwStep8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 66,
    viewBox: "0 0 74 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.2012 21.2004L65.1813 17.2203",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1813 49.0615L61.2012 45.0814",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1611 33.1409H73.1413",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.259 45.0814L9.29004 49.0615",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29004 17.2203L13.259 21.2004",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31024 33.1409H1.33008",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5778 1.29962H54.8708C56.1075 1.29962 57.1194 2.31153 57.1194 3.5483V62.7222C57.1194 63.959 56.1075 64.9709 54.8708 64.9709H19.5778C18.341 64.9709 17.3291 63.959 17.3291 62.7222V3.5483C17.3291 2.31153 18.341 1.29962 19.5778 1.29962Z",
    fill: "white",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7549 55.0317H41.7046",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6896 45.9696H22.7604C21.5236 45.9696 20.5117 44.9577 20.5117 43.7209V7.1462C20.5117 5.90943 21.5236 4.89752 22.7604 4.89752H51.6896C52.9264 4.89752 53.9383 5.90943 53.9383 7.1462V43.7209C53.9383 44.9689 52.9376 45.9696 51.6896 45.9696Z",
    fill: "white",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9382 33.5681L47.2821 28.2388C46.4389 27.5642 45.2021 27.6991 44.5162 28.5423L39.4567 34.8611C38.7821 35.7044 37.5453 35.8505 36.6908 35.1647L34.1386 33.1184C33.3066 32.455 32.081 32.5675 31.3952 33.3995L24.4355 45.9583H52.5777C52.5777 45.9583 53.9269 45.7222 53.9269 44.6091C53.9382 42.3492 53.9382 33.5681 53.9382 33.5681Z",
    fill: "#63C7C9",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0564 21.2566C28.2588 21.6726 28.5398 22.0099 28.7984 22.291C29.2594 22.797 29.7879 23.2579 30.2938 23.6964C30.5636 23.9325 30.8447 24.1687 31.1033 24.416C31.272 24.5734 31.4631 24.6521 31.6543 24.6521C31.8454 24.6521 32.0478 24.5734 32.2277 24.4048C32.7336 23.955 33.2396 23.5053 33.7343 23.0443C34.2515 22.5721 34.645 22.1561 34.9486 21.7288C35.3196 21.2229 35.477 20.6607 35.4208 20.0536C35.3646 19.4127 35.0385 18.9292 34.5101 18.6369C33.5431 18.131 32.4076 18.2209 31.643 18.8618C31.0471 18.3671 30.2938 18.1984 29.473 18.3783C28.8771 18.5132 28.4499 18.7718 28.1576 19.1878C28.0002 19.4127 27.9327 19.6601 27.8765 19.8624L27.8652 20.6045L27.8877 20.7507C27.9327 20.9081 27.9664 21.0767 28.0564 21.2566Z",
    fill: "#5458F7",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWwStep8);
export default __webpack_public_path__ + "static/media/ww-step8.ffc1ca40.svg";
export { ForwardRef as ReactComponent };